<template>
    <div class="form-container active" id="step-3">
        <div class="row justify-content-around">
            <!-- Afficher AppointementSummaryLg après validation des champs extra -->
            <div v-if="shouldShowAppointmentSummaryLg">
                <AppointementSummaryLg 
                    :config="config"
                    :prestations="store.selected_prestations"
                    :prestations_fields="prestations_fields"
                    :start_date="current_rdv_data.start_date"
                    :start_hour="current_rdv_data.heure" 
                    :freetimeTitle="current_rdv_data.free_time_title"
                    :rdv_data="current_rdv_data" 
                    :rdvs_data="rdv_data" 
                    :location="location"
                    :attachment="attachment"
                    :current_index="current_rdv_index" 
                    @update-attachment="onAttachmentUpdate"
                    @back="this.$emit('backToFirstStep')">
                </AppointementSummaryLg>
            </div>
            <div v-else class="col-lg-3">
                <appointment-summary ref="ref_summary" :config="config" :prestations="prestations"
                :start_date="current_rdv_data?.start_date"
                :start_hour="current_rdv_data?.heure"
                :freetimeTitle="current_rdv_data?.free_time_title"
                :location="location"  :rdvs="rdvs_data" @back="this.$emit('backToFirstStep')">
                </appointment-summary>
            </div>
            <div v-if="rdv_not_for_me && !withAuth && is_btn_validate_enabled && current_rdv_data" class="col-lg-9">
                <sign-up ref="ref_final_client_form" :key="'ref_final_client_form-'+current_rdv_index"
                         :config="config" :form_only="true"
                         :title="'Coordonnées du professeur de la classe '+  (current_rdv_index + 1)"
                         :withAuth="withAuth" @submitWithoutAuth="set_current_rdv_client($event)"
                >
                </sign-up>
            </div>
            
            <div v-if="(user || get_client_infos) && showExtraFieldsForm
                && !extraFieldsValidated && prestations_fields.length > 0 && !(rdv_not_for_me && !withAuth && is_btn_validate_enabled)" class="col-lg-6 rdv-extra border-start">
                <RdvExtraFieldsForm
                    ref="rdv_extra_fields_form"
                    :rdv_data="current_rdv_data"
                    :prestations="prestations"
                    :config="config"
                    :group_size="group_size"
                    :fo_config="fo_config"
                    :prestations_fields="prestations_fields"
                    :initial-attachment="existingAttachment"
                    @fields-validated="onRdvFieldsValidated"
                    @form-validity-changed="handleFormValidity"
                    @next-step="onRdvFieldsValidated"
                    @update-attachment="onAttachmentUpdate"
                    @back="handleBack"
                    >
                </RdvExtraFieldsForm>
            </div>
            <AttendiesForm v-if="(user || get_client_infos) && this.group_size > 1 && 
                !current_rdv_data?.rdv_id" :prestations="prestations"
                :rdv_data="current_rdv_data" :group_size="group_size"
                :config="config"
                @can-submit="can_submit = $event" @update-attachment="onAttachmentUpdate"
                @participants-modify="onParticipantsModify"
                class="col-lg-6">
            </AttendiesForm>
            <div v-if="config['FORM_POSITION'] == 0" class="col-lg-6">
                <div v-if="!user && withAuth === true">
                    <!-- <sign-in @userLogin="set_user($event)" @signUp="signup = $event" v-show="!signup"></sign-in> -->
                    <!-- <sign-up :config="config" :withAuth="withAuth" @sign-in="signup = $event" v-show="signup"></sign-up> -->

                    <sign-in 
                        @userLogin="set_user($event)" 
                        @signUp="signup = $event" 
                        @forgottenPassword="show_forgotten_password = true"
                        v-show="!signup && !show_forgotten_password">
                    </sign-in>
                    <sign-up 
                        :config="config" 
                        :withAuth="withAuth" 
                        @sign-in="signup = $event" 
                        v-show="signup && !show_forgotten_password">
                    </sign-up>
                    <ForgottenPassword 
                        v-show="show_forgotten_password" 
                        @showSignIn="show_forgotten_password = false">
                    </ForgottenPassword>
                </div>
                <div v-else>
                    <sign-up :config="config" :withAuth="withAuth" @sign-in="signup = $event" @submitWithoutAuth="submitClientInfos($event)" v-show="!get_client_infos && !user"></sign-up>
                </div>
            </div>
        </div>
        <div class="btn-container">
            <a v-if="config['ENABLE_HEADER_FOOTER'] == 0" class="iframe-logo" href="#">
              <img src="/assets/images/logo-footer.svg" alt="logo">
            </a>
            <div class="buttons-right">
                <button class="btn-secondary1" id="prevBtn" @click="handleBack()">Modifier le créneau</button>
                <button v-if="!extraFieldsValidated && showExtraFieldsForm && prestations_fields.length > 0 && !(is_btn_validate_enabled)"
                    class="btn-primary1 enregistrer"
                    :disabled="!isFormValid || (prestations[0].force_attachment && !attachment && this.config['MULTIPLE_RDV'] == 0)" 
                    @click="handleNextStep"
                >
                    Suivant
                </button>
                <ConfirmationPopUp ref="ref_confirmation_popup"
                    v-else-if="(user || get_client_infos) &&
                    (config['MULTIPLE_RDV'] != 1 || (config['MULTIPLE_RDV'] == 1 &&
                    current_rdv_index >= Object.keys(this.rdv_data).length ))"
                    :key="'ref_confirmation_popup-'+current_rdv_index"
                    :agenda="agenda"
                    :config="config"
                    :rdv_data="rdv_data"
                    :rdvs_data="get_rdv_data"
                    :attendees="getAttendeesFromRdv(rdv)"
                    :client_infos="get_client_infos"
                    :withAuth="withAuth"
                    :autoSelectNext="withAutoSelectNext()"
                    :location="location"
                    :duration="getDuration"
                    :price="getPrice"
                    :prestations="prestations"
                    :participants="participants"
                    :group_size="group_size"
                    :prestations_ids="this.getSelectedPrestationsIds()"
                    :start_date="formatDateMoment(current_rdv_data?.start_date, 'DD/MM/YYYY à HH:mm')"
                    :fo_config="fo_config"
                    :attachment="attachment"
                    :hide_toggle_btn="is_btn_validate_enabled"
                    :toggle_from_outside="false"
                    :show_modal="false"
                    @showSystempayForm="systempayFormToken = $event"
                >
                </ConfirmationPopUp>
                <button v-if="is_btn_validate_enabled" class="btn-primary1" id="nextBtn" @click="rdv_not_for_me ? validate_for_someone_else() : validate()">Valider</button>            
            </div>
            
            <!-- Modals de paiement -->
            <systempay-smart-form ref="ref_systempay_smart_form" v-if="systempayFormToken"
                :showModal="true"
                :publicKey="config?.systempay?.options?.public_key"
                :formToken="systempayFormToken"
                @close="closeSystempay"
                @paid="onSystempayPaid"
                >
            </systempay-smart-form>
        </div> 
    </div>
</template>

<script>
import AppointmentSummary from './AppointmentSummary.vue';
import ForgottenPassword from '../Auth/ForgottenPassword.vue';
import SignIn from '../Profile/SignIn.vue';
import SignUp from '../Profile/SignUp.vue';
import RdvExtraFieldsForm from './RdvExtraFieldsForm.vue'; //
import ConfirmationPopUp from '../SharedComponents/ConfirmationPopUp.vue';
import axios from 'axios';
import moment from 'moment';
import AppointementSummaryLg from './AppointementSummaryLg.vue';
import { Inertia } from '@inertiajs/inertia';
import { BookingStore } from '../Stores/BookingStore';
import AttendiesForm from './AttendiesForm.vue';
import SystempaySmartForm from '../SharedComponents/SystempaySmartForm.vue';


export default {
    name: 'SelectTimeSlot',
    emits: ['back','submit', 'next-step', 'backToFirstStep'],
    components: { AppointmentSummary, SignIn, SignUp, ConfirmationPopUp, AppointementSummaryLg,
        AttendiesForm, AppointmentSummary , ForgottenPassword, RdvExtraFieldsForm, SystempaySmartForm
    },
    props: ['agendas','agenda', 'config', 'locations','location','location_id','prestations', 'group_sizes', 'fo_config', 'price', 'rdv_data', 'rdv', 'rdv_not_for_me'],

    data(){
        return {
            store: BookingStore,
            prestations_fields: [],
            participants_fields: [],
            participants: [],
            signup: false,
            rdvs_data: {},
            // current_rdv_data: null,
            current_rdv_index: 0,
            client_infos: null,
            days: {},
            free_times: [],
            group_size: null,
            is_loading: false,
            show_popup: false,
            time_slot_clicked: false,
            start_date: null,
            logged_user: this.user,
            can_submit: false,
            attachment: null,
            show_forgotten_password: false,
            extraFieldsValidated: false,
            isFormValid: false,
            prestations_fields_loaded: false,
            existingAttachment: null,
            isLoadingAttachment: false,
            attachmentLoadedForRdv: null,
            systempayFormToken: null
        }
    },
    computed: {
        is_btn_validate_enabled(){
            // return this.config['MULTIPLE_RDV'] == 1 && this.current_rdv_index < Object.keys(this.rdv_data).length;
             if(!this.rdv_data || typeof this.rdv_data !== 'object') return false;
                return this.config['MULTIPLE_RDV'] == 1 && this.current_rdv_index < Object.keys(this.rdv_data).length;
        },
        // détermine si on doit afficher le formulaire des champs extra
        showExtraFieldsForm() {
            // console.log('prestations_length: ',this.prestations.length);
            // console.log('prestationsis_group', this.prestations[0]?.is_group);
            // console.log('prestationsfield', this.prestations_fields);
            return this.prestations.length > 0 
                && this.prestations[0]?.is_group == 0 
                && this.group_size == 1;
        },
        shouldShowAppointmentSummaryLg() {
            if (!(this.user || this.get_client_infos)) return false;
            if (!this.current_rdv_data) return false;
            if (!(this.group_size === 1 || this.current_rdv_data.rdv_id)) return false;
            if (this.rdv_not_for_me && (!this.rdv_data || 
                Object.keys(this.rdv_data).length === 0 || 
                this.current_rdv_index < Object.keys(this.rdv_data).length)) {
                return false;
            }
            const shouldShowSummary = (!this.showExtraFieldsForm || this.extraFieldsValidated) ||
                                    (this.prestations_fields_loaded && this.prestations_fields.length === 0);
            
            return shouldShowSummary;
        },
        current_rdv_data(){
            let rdv = null;
            console.log('Validate appointment current_rdv_data',this.store.rdvToModify);
            // Si modification renvoyer le rdv du store
            if(this.store.rdvToModify) return this.store.rdvToModify;

            if(!this.rdv_data || typeof this.rdv_data !== 'object') return null;

            if(this.config['MULTIPLE_RDV'] == 1){
                const keys = Object.keys(this.rdv_data);
                if(keys.length === 0) return null;
                // rdv = this.rdv_data[Object.keys(this.rdv_data)[this.current_rdv_index < Object.keys(this.rdv_data).length ? this.current_rdv_index : Object.keys(this.rdv_data).length-1]+''];
                const safeIndex = this.current_rdv_index < keys.length 
                    ? this.current_rdv_index 
                    : keys.length - 1;
                rdv = this.rdv_data[keys[safeIndex]];
                // console.log("rdv =====>>>", rdv);
                // console.log("rdv_id:", this.current_rdv_data?.rdv_id);
                // console.log("config['FORM_POSITION']:", this.config['FORM_POSITION']);
                // console.log('get from object',this.config['MULTIPLE_RDV'],this.config['MULTIPLE_RDV'] == 1,Object.keys(this.rdv_data)[this.current_rdv_index],rdv);
            }else{
                rdv = this.rdv_data;
                // console.log('get from rdv',this.config['MULTIPLE_RDV'],this.config['MULTIPLE_RDV'] == 1,rdv);
            }
            return rdv;
        },
        get_rdv_data(){
            return this.rdv_data;
        },
        get_client_infos() {
            return this.client_infos
        },
        allow_subgroup () {
            this.prestations[0]?.allow_subgroup
        },
        getPrice () {
            if (
                !this.config.display_price
                ||
                this.prestations.find(prestation => !prestation.display_price)
            ) return 'Non communiqué'
            return this.price;
        },
        getDuration () {
            if (
                !this.config.display_duration
                ||
                this.prestations.find(prestation => !prestation.display_duration)
            ) return 'Durée non communiquée'

            let duration = this.prestations.reduce((accumulator, prestation) => accumulator += prestation.duration, 0)
            let hours = Math.floor(duration / 60)
            let minutes = duration % 60
            if (minutes < 10 && minutes != 0) minutes = '0' + minutes
            let str = ''
            if (hours) str += hours + 'h'
            if (minutes) str += minutes + ' minutes'
            return str
        },
        user() {
            return this.$page.props.auth.user?.client?.[0]
        },
        redirected(){
            return this.fo_config && (this.fo_config['redirected'] == 1);
        },
        withAuth(){
            // console.log(!(this.config && this.config["BOOK_WITHOUT_SUBSCRIPTION"] && this.config["BOOK_WITHOUT_SUBSCRIPTION"] == 1))
            return !(this.config && this.config["BOOK_WITHOUT_SUBSCRIPTION"] && this.config["BOOK_WITHOUT_SUBSCRIPTION"] == 1);
        },
    },

    methods: {
        handleFormValidity(isValid) {
            this.isFormValid = isValid;
        },
        handleNextStep() {
            if (this.$refs.rdv_extra_fields_form && this.$refs.rdv_extra_fields_form.goToNextStep) {
                this.$refs.rdv_extra_fields_form.goToNextStep();
            }
            console.log('handleNextStep rdvs before', this.rdv_data, this.rdv, this.rdvs_data);
            // Handle multple rdv clients
            if(this.config["FORM_POSITION"] != 1 && this.config['MULTIPLE_RDV'] == 1 && this.config["RDV_FOR_SOMEONE_ELSE"] == 1){
                if(this.config["BOOK_WITHOUT_SUBSCRIPTION"] == 1){
                    // TODO
                }else{
                    this.set_connected_client_to_rdvs();
                }
            }
            console.log('handleNextStep rdvs after', this.rdv_data, this.rdv, this.rdvs_data);
        },
        // callback quand les champs extra sont validés
        onRdvFieldsValidated(fieldData) {
            // store the form data or send it to the next component if needed
            this.validatedExtraFields = fieldData;
           // Propager les extra fields à TOUS les créneaux
            if(this.config['MULTIPLE_RDV'] == 1 && this.rdv_data){
                for(const key in this.rdv_data){
                    Object.assign(this.rdv_data[key], fieldData);
                }
            } else {
                // Mode single RDV
                Object.assign(this.current_rdv_data, fieldData);
            }
             // Notifier ConfirmationPopUp avec les données complètes
            this.$nextTick(() => {
                if (this.$refs.ref_confirmation_popup) {
                    this.$refs.ref_confirmation_popup.updateRdvData(this.current_rdv_data);
                }
            });
            this.extraFieldsValidated = true;
            window.scrollTo({ top: 0, behavior: 'smooth' }); 
        },


        validate(){
            this.set_current_rdv_client();
            if(!this.is_btn_validate_enabled){
                this.$refs.ref_confirmation_popup.set_show(true);
            }
            this.current_rdv_index++;
            // this.set_current_rdv_client();
        },
        validate_for_someone_else(){
            if(this.$refs.ref_final_client_form.saveWithoutAuth()){
                this.current_rdv_index++;
                if(!this.is_btn_validate_enabled){
                    // console.log("validate_for_someone_else show popup",this.$refs.ref_confirmation_popup);
                    this.$refs.ref_confirmation_popup?.set_show(true);
                }
            }
        },
        set_connected_client_to_rdvs(){
            for (const key in this.rdv_data) {
                this.rdv_data[key]['by_client'] = this.user;
                this.rdv_data[key]['for_client'] = this.user;
            }
        },
        set_current_rdv_client(client=null){

            let rdv = this.current_rdv_data;
            if(rdv){
                rdv.by_client = this.get_client_infos;
                rdv.for_client = client ?? this.get_client_infos;
                // console.log("set_current_rdv_client", this.current_rdv_data);
            }
        },

        onParticipantsModify(data) {
            this.participants = data
        },
        onAttachmentUpdate(file) {
            console.log('📎 ValidateAppointment - onAttachmentUpdate:', file);
            if (file && !(file.isExisting)) {
                this.attachmentLoadedForRdv = null; // Reset pour permettre rechargement futur
            }
            this.attachment = file;
            this.existingAttachment = file;
            
            if (this.current_rdv_data) {
                console.log('current_rdv_data', this.current_rdv_data);
                this.current_rdv_data.attach = file;
            }
            this.$forceUpdate(); // Forcer la détection de changement
            console.log('📎 ValidateAppointment - Attachment mis à jour:', this.attachment);
        },
        async getExistingAttachment() {
            try {
                // Vérifier si on a un rendez-vous existant avec ID
                if (!this.current_rdv_data?.rdv_id) {
                    console.log('Aucun ID de rendez-vous trouvé');
                    return null;
                }

                // Appeler l'API pour récupérer le chemin du fichier
                const response = await axios.get('/rdv/attach', {
                    params: {
                        rdv_id: this.current_rdv_data.rdv_id,
                        client_id: this.current_rdv_data.client_id || this.user?.client_id
                    }
                });

                if (response.data.attachment_path) {
                    console.log('📎 Attachment trouvé:', response.data.attachment_path);
                    
                    // Option 1: Retourner juste les métadonnées
                    return {
                        path: response.data.attachment_path,
                        name: response.data.file_name || this.extractFileName(response.data.attachment_path),
                        isExisting: true
                    };
                }
                
                console.log('Aucun attachment trouvé pour ce rendez-vous');
                return null;

            } catch (error) {
                console.error('❌ Erreur lors de la récupération de l\'attachment:', error);
                
                // Si c'est une 404, c'est normal (pas d'attachment)
                if (error.response?.status === 404) {
                    console.log('Aucun attachment existant');
                    return null;
                }
                
                return null;
            }
        },

        // Méthode utilitaire pour extraire le nom du fichier du chemin
        extractFileName(filePath) {
            if (!filePath) return 'fichier_joint';
            return filePath.split('/').pop() || 'fichier_joint';
        },

        // Méthode optionnelle pour télécharger le fichier et créer un File object
        async downloadAttachmentFile(filePath) {
            try {
                const response = await axios.get('/api/rdv/attachment/download', {
                    params: {
                        rdv_id: this.current_rdv_data.rdv_id,
                        client_id: this.current_rdv_data.client_id || this.user?.client_id
                    },
                    responseType: 'blob'
                });

                // Créer un File object à partir du blob
                const blob = new Blob([response.data]);
                const fileName = this.extractFileName(filePath);
                
                return new File([blob], fileName, { 
                    type: response.headers['content-type'],
                    lastModified: new Date().getTime()
                });

            } catch (error) {
                console.error('Erreur lors du téléchargement du fichier:', error);
                return null;
            }
        },

        // Modifier loadExistingData pour utiliser getExistingAttachment
        async loadExistingData() {
            // ✅ Éviter les appels multiples pour le même RDV
            if (this.isLoadingAttachment) {
                console.log('⏸️ Chargement déjà en cours, ignoré');
                return;
            }
            
            if (!this.current_rdv_data?.rdv_id) {
                console.log('❌ Pas de RDV ID, ignoré');
                return;
            }
            
            // ✅ Vérifier si on a déjà chargé pour ce RDV
            if (this.attachmentLoadedForRdv === this.current_rdv_data.rdv_id) {
                console.log('ℹ️ Attachment déjà chargé pour ce RDV:', this.current_rdv_data.rdv_id);
                return;
            }
            
            this.isLoadingAttachment = true;
            
            try {
                console.log('🔄 Chargement des données existantes pour le RDV:', this.current_rdv_data.rdv_id);
                this.existingAttachment = await this.getExistingAttachment();
                
                if (this.existingAttachment) {
                    console.log('✅ Attachment chargé:', this.existingAttachment);
                    this.attachment = this.existingAttachment;
                    this.attachmentLoadedForRdv = this.current_rdv_data.rdv_id; // ← Marquer comme chargé
                }
            } catch (error) {
                console.error('❌ Erreur loadExistingData:', error);
            } finally {
                this.isLoadingAttachment = false;
            }
        },
        has_presta_group(){
            return this.prestations[0]?.is_group;
        },
        get_prestations_fields(){
            // console.log("IDs envoyés à /prestations/extrafields :", this.getSelectedPrestationsIds());
            axios.get('/prestations/extrafields',{params: {ids: this.getSelectedPrestationsIds(), has_presta_group: this.has_presta_group()}}).then(response => {
                this.prestations_fields = response.data['presta_ext_fields'].sort((a, b) => a.position - b.position);
                this.participants_fields = response.data['attendee_presta_ext_fields'].sort((a, b) => a.position - b.position);
                this.prestations_fields_loaded = true;
                console.log('prestations_field', this.prestations_fields);
            })
        },
        set_user(){
            // Inertia.reload({ only: ["auth.user"] });
            // Inertia.get('/ressources')
        },
        getAttendeesFromRdv(rdv){
            if (!rdv?.participants) return null;
    
            const participant = rdv.participants.find(p => p.client_id === this.user?.client_id);
            return participant ? JSON.parse(participant.attendees ?? '[]') : null;
        },
        // withAuth(){
        //     console.log(this.config && this.config["BOOK_WITHOUT_SUBSCRIPTION"] && this.config["BOOK_WITHOUT_SUBSCRIPTION"] == 1)
        //     return !(this.config && this.config["BOOK_WITHOUT_SUBSCRIPTION"] && this.config["BOOK_WITHOUT_SUBSCRIPTION"] == 1);
        // },
        withAutoSelectNext(){
            return (this.config && this.config["AUTO_BOOKING"] && this.config["AUTO_BOOKING"] == 1);
        },
        formatDateMoment(date, format) {
            if(!date) return null;
            return moment(date).locale('fr').format(format)
        },
        getSelectedPrestationsIds(){
            // alert(JSON.stringify(this.prestations ?? []));
            return this.prestations.map(prestation => prestation.prestation_id);
        },
        parseUrl() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('agenda_id') && parseInt(urlParams.get('agenda_id'))) {
                this.agenda_id = urlParams.get('agenda_id')
                this.agenda = this.agendas.find(agenda => agenda.agenda_id == this.agenda_id)
                if (!this.agenda) return this.$inertia.get('/ressources')
            }
            if (!this.location) return this.$inertia.get('/ressources')
            // if (urlParams.get('location_id') && parseInt(urlParams.get('location_id'))) {
            //     this.location_id = urlParams.get('location_id')
            //     this.location = this.locations.find(location => location.location_id == this.location_id)
            //     if (!this.location) return this.$inertia.get('/ressources')
            // }
            if (this.prestations.find(prestation => prestation.is_group)) {
                if (this.prestations.length > 1) {
                    toast({
                        message: 'Impossible de combiner les prestations de groupe avec d\'autre prestations.',
                        type: 'is-danger',
                        duration: 4000,
                        pauseOnHover: true
                    })
                    return this.$inertia.get('ressources')
                }
                let prestation = this.prestations[0]
                if (!prestation.allow_subgroup) this.group_size = 1
                else this.group_size = parseInt(urlParams.get('group_size')) || 1
            }
        },
        toggleAuthModal () {
            let modal = document.querySelector('#auth-modal')
            modal.classList.toggle('is-active')
        },
        submitClientInfos(data){
            // console.log("submitClientInfos");
            
            this.client_infos = data;
            this.show_popup = true;
            // console.log(this.submitClientInfos, data)
        },
        handleBack() {
             if(this.extraFieldsValidated && this.showExtraFieldsForm) {
                // Si on est sur l'écran de summary, revenir aux champs extra
                this.extraFieldsValidated = false;
            } else if(this.config["AUTO_BOOKING"] == 1){                
                this.$emit('backToFirstStep')
            } else {
                this.$emit('back')
            }
            // if(this.config["AUTO_BOOKING"] == 1){                
            //     this.$emit('backToFirstStep')
            //     return
            // }
            
            // this.$emit('back')
        },
        goto_last_index(){
            this.current_rdv_index = Object.keys(this.rdv_data ?? {}).length;
        },
        onSystempayPaid(){
            this.showSystempayForm = false;
            this.systempayFormToken = null;

            this.$inertia.get(this.withAuth ? '/account' : '/ressources');
        },

        closeSystempay() {
            this.showSystempayForm = false;
            this.systempayFormToken = null;
        },
    },
    mounted () {
        console.log("validate_appointment component", this.store.rdvToModify);

        window.scrollTo({ top: 0, behavior: 'smooth' }); // sroll
        
        // this.parseUrl();

        if (this.config['FORM_POSITION'] == 1) { 
            this.submitClientInfos(BookingStore.user_infos)
            // console.log('DONE');
        }
        // Initialiser taille du groupe mettre à un seul groupe
        this.group_size = BookingStore.get_groupe_size();
        

        // Initialisation du token et authentification de l'utilisateur
        if(this.fo_config['redirected'] == 1){
            let token = (new URLSearchParams(location.search)).get('token');
            if(token){
                axios.post('/redirect/auth/login', {
                    token: token
                })
                .then(response => {
                    this.form_error = null;
                    let user = response.data.client;
                    this.$emit('userLogin', user);
                    Inertia.reload({ only: ["auth.user"] });
                })
                .catch(err => {
                    this.form_error = err?.response?.data?.message ?? 'Une erreur est survenue'
                })   
            }
        }

        // if (!this.location) return this.$inertia.get('/ressources')

        // Initialisation rdv multiple 
        if(!this.rdv_not_for_me){
            this.goto_last_index();
            this.set_current_rdv_client();
        }
        if (this.current_rdv_data?.rdv_id) {
            this.loadExistingData();
        }
    },
    watch: {
        user(value) {
            if (value && this.current_rdv_data && this.time_slot_clicked) this.show_popup = true;
        },
        prestations: {
            immediate: true,
            handler() {
                this.get_prestations_fields();
            }
        },
        // Recharger l'attachment quand le RDV change
        current_rdv_data: {
            deep: true,
            handler(newRdv, oldRdv) {
                // ✅ Ne recharger que si le RDV ID a vraiment changé
                if (newRdv?.rdv_id && newRdv.rdv_id !== oldRdv?.rdv_id) {
                    console.log('🔄 RDV changé:', oldRdv?.rdv_id, '→', newRdv.rdv_id);
                    this.loadExistingData();
                }
            }
        }
    },
}

</script>

<style>
    /* Buttons */
    .enregistrer:disabled{
        cursor: not-allowed;
        background-color: #07070733;
        border: none;
    }
    @media (max-width: 992px) {
        .border-start {
            border-left: none !important;
        }
    }
</style>

